import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { specialList } from "@/mocks/special";

export default function HomeSpecialSection() {
  const [main, ...rest] = specialList;

  return (
    <section className="w-full bg-background-50 px-4 py-14 md:px-8 md:py-20 lg:px-12">
      <SectionHeading
        kicker="Special Features"
        title="专题推荐"
        description="我们为重要的作品节点与长久被讨论的话题，整理成可以慢慢读的专题合集。"
        action={
          <Link
            to="/special"
            className="inline-flex w-fit cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full border border-background-300 px-4 py-2 text-xs text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700"
          >
            全部专题
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        }
      />

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-[1.2fr_1fr]">
        <Link
          to={`/special/${main.id}`}
          className="group relative flex flex-col justify-end overflow-hidden rounded-lg bg-foreground-950"
        >
          <div className="absolute inset-0">
            <img
              src={main.cover}
              alt={`${main.title} - 张柏芝专题封面`}
              title={`${main.title} - 张柏芝专题`}
              className="h-full w-full object-cover object-top opacity-90 transition-transform duration-700 group-hover:scale-105"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/95 via-foreground-950/45 to-foreground-950/15"></div>
          <div className="relative min-h-[320px] p-5 md:min-h-[380px] md:p-8">
            <div className="flex flex-wrap items-center gap-2">
              <span className="rounded-full bg-primary-500 px-3 py-1 text-[11px] text-background-50">
                {main.kicker}
              </span>
              <span className="rounded-full border border-background-50/35 px-3 py-1 text-[11px] text-background-100">
                {main.period}
              </span>
            </div>
            <h3 className="mt-4 max-w-xl font-heading text-xl font-semibold leading-snug text-background-50 md:text-[28px]">
              {main.title}
            </h3>
            <p className="mt-3 line-clamp-2 max-w-xl text-[13px] leading-6 text-background-200">{main.intro}</p>
            <div className="mt-5 flex items-center gap-3 text-[11px] text-background-300">
              <span>{main.articleCount} 篇内容</span>
              <span className="h-3 w-[1px] bg-background-50/30"></span>
              <span className="flex items-center gap-1 text-primary-300">
                进入专题
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </span>
            </div>
          </div>
        </Link>

        <div className="flex flex-col gap-4">
          {rest.map((item) => (
            <Link
              key={item.id}
              to={`/special/${item.id}`}
              className="group flex gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300"
            >
              <div className="h-24 w-28 shrink-0 overflow-hidden rounded-md bg-background-200 md:h-24 md:w-32">
                <img
                  src={item.cover}
                  alt={`${item.title} - 张柏芝专题封面`}
                  title={`${item.title} - 张柏芝专题`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex min-w-0 flex-col justify-center">
                <div className="flex items-center gap-2 text-[11px] text-foreground-500">
                  <span className="rounded-sm bg-secondary-200/70 px-1.5 py-0.5 text-secondary-900">{item.tag}</span>
                  <span>{item.period}</span>
                </div>
                <h3 className="mt-1.5 line-clamp-2 font-heading text-sm font-semibold leading-6 text-foreground-950 transition-colors group-hover:text-primary-700">
                  {item.title}
                </h3>
                <p className="mt-1 line-clamp-1 text-[11px] text-foreground-500">{item.intro}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}